import React, { Component } from 'react';
import _ from 'lodash';

import UserTable from '../components/UserTable';
import UserForm from '../components/UserForm';

import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class SettingsServicesScreen extends Component {

  state = {    
    dataLoading: true,
    dataAll: [],
    data: [],              
    userFormModalVisible: false,    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    UserModel.getAll()
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      })
      .catch(err => {
        message.warning('Uživatele se nepodařilo načíst!')
        this.setState({
          dataLoading: false, 
          dataAll: [],
          data: []        
        });
      });
  }

  onSearch(searchText) {        
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['username'].startsWith(searchText); })
    })
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Uživatelé</h2>
          <div style={{marginBottom: '20px'}}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Hledat uživ. jméno"
                  onSearch={this.onSearch.bind(this)} 
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{textAlign: 'right'}}>
                <Button type="default" onClick={() => { this.loadData() }} style={{marginRight: 10}}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'SYSTEM_USERS_WRITE']) 
                  ? <Button type="default" onClick={() => { this.setState({userFormModalVisible: true}) }}>Nový uživatel</Button>
                  : null}
              </Col>
            </Row>          
          </div>
          <UserForm 
            type="modal" 
            modalVisible={this.state.userFormModalVisible} 
            onModalCancel={()=>{this.setState({ userFormModalVisible: false })}}
            onSuccess={(form, values) => { 
              console.log(values);                    
              UserModel.create(values)
                .then(() => {
                  form.resetFields(); 
                  this.loadData();
                });    
            }} />
          <UserTable
            data={this.state.data} 
            loading={this.state.dataLoading}
            onRemoveRow={(id)=>{
              UserModel.remove(id)
                .then(() => {
                  this.loadData();
                });                                          
            }}
            />            
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsServicesScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsUsersScreen.js